 
import { inject } from '@angular/core';
import { HttpInterceptorFn, HttpRequest, HttpHandlerFn } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { concatMap, catchError, take, map } from 'rxjs/operators';
import { LocalRepository } from '@shared/helper/local-repository';
import { ACCESS_TOKEN_KEY, ACCESS_TOKEN_KEY_CLIENT } from 'constants/storage-keys';


const getToken = (repo: LocalRepository): Observable<string> => {
    const token = repo.getCookieItem(ACCESS_TOKEN_KEY);
    const client_token = repo.getCookieItem(ACCESS_TOKEN_KEY_CLIENT)!;
    return token ? of(token) : of(client_token);
};

const addTokenToRequest = (request: HttpRequest<any>, token: string): HttpRequest<any> => {
    if (!token) {
        return request;
    }
    const headers = { 'Authorization': `Bearer ${token}` };
    return request.clone({ setHeaders: headers });
};

const addXClientIdToRequest = (request: HttpRequest<any>): HttpRequest<any> => {
    const headers = { 'X-Client-Id': 'api.angular.client' };
    return request.clone({ withCredentials: true, setHeaders: headers });
};

const handleAuth = (request: HttpRequest<any>, repo: LocalRepository): Observable<HttpRequest<any> | null> => {

    request = addXClientIdToRequest(request);

    return getToken(repo).pipe(
        take(1),
        map(token => addTokenToRequest(request, token)),
        catchError(() => {
            return of(null);
        })
    );
};

export const authInterceptor: HttpInterceptorFn = (request: HttpRequest<any>, next: HttpHandlerFn): Observable<any> => {
    const repo = inject(LocalRepository);
    return handleAuth(request, repo).pipe(
        concatMap(req => req?.url.includes('undefined') ? of(null) : next(req!))
    );
};